import { useState } from 'react';
import { OrderCondition } from '../../conditions/interfaces/orderCondition.interface';

export const ALL_ORDER_CONDITIONS_ID = 'all';

interface UseSelectedOrderConditionParams {
  orderConditions: OrderCondition[];
}

const useSelectedOrderCondition = ({ orderConditions }: UseSelectedOrderConditionParams) => {
  const [selectedConditionId, setSelectedConditionId] = useState(ALL_ORDER_CONDITIONS_ID);

  const selectedCondition = orderConditions.find(
    (condition) => condition.id === selectedConditionId,
  );

  return {
    selectedConditionId: selectedCondition?.id ?? ALL_ORDER_CONDITIONS_ID,
    selectedCondition,
    isAllConditionsSelected: !selectedCondition,
    selectCondition: setSelectedConditionId,
  };
};

export default useSelectedOrderCondition;
